import { enumTheme } from "../../interfaces/Site";
import { BorderUpAndDown, IEventLogoBorderUpAndDown } from "./EventLogos/BorderUpAndDown/BorderUpAndDown";
import {
    IEventLogoModernMonogramBadge,
    ModernMonogramBadge,
} from "./EventLogos/ModernMonogramBadge/ModernMonogramBadge";
import {
    IEventLogoModernMonogramStrikethrough,
    ModernMonogramStrikethrough,
} from "./EventLogos/ModernMonogramStrikethrough/ModernMonogramStrikethrough";
import { IEventLogoRelaxedByHand, RelaxedByHand } from "./EventLogos/RelaxedByHand/RelaxedByHand";
import styles from "./EventLogo.module.scss";
import { EventLogoAutoShrink } from "./components/EventLogoAutoShrink/EventLogoAutoShrink";
import { TPrintableCardLayout } from "../../views/GeneratorEdit/views/ViewCommunication/components/EditPrint/components/PrintEditor/interfaces/IPrintableCard";
import { HandDrawnHeart, IEventLogoHandDrawnHeart } from "./EventLogos/HandDrawnHeart/HandDrawnHeart";
import { IEventLogoModernMonogramBorderBetween, ModernMonogramBorderBetween } from "./EventLogos/ModernMonogramBorderBetween/ModernMonogramBorderBetween";

export const eventLogoComponents = [
    "RelaxedByHand",
    "BorderUpAndDown",
    "ModernMonogramStrikethrough",
    "ModernMonogramBadge",
    "HandDrawnHeart",
    "ModernMonogramBorderBetween"
] as const;
export type TEventLogoComponent = (typeof eventLogoComponents)[number];

export type TEventLogo =
    | IEventLogoRelaxedByHand
    | IEventLogoBorderUpAndDown
    | IEventLogoModernMonogramBadge
    | IEventLogoModernMonogramStrikethrough
    | IEventLogoHandDrawnHeart
    | IEventLogoModernMonogramBorderBetween;

export type TEventLogoType = "SITE" | "DEMO" | "PRINT";

interface IProps {
    eventLogo: TEventLogo;
    type: "SITE";
    siteTheme: enumTheme;
}

interface IPropsPrint {
    eventLogo: TEventLogo;
    type: "PRINT";
    cardLayout: TPrintableCardLayout;
}

interface IPropsDemo {
    type: "DEMO";
    eventLogoComponent: TEventLogoComponent;
}

export function EventLogo(props: IPropsDemo | IProps | IPropsPrint) {
    let cssVars;

    if (props.type === "DEMO") {
        cssVars = styles.demo;
    } else if (props.type === "SITE") {
        cssVars = styles[props.siteTheme];
    } else if (props.type === "PRINT") {
        cssVars = styles[props.cardLayout];
    } else {
        throw new Error("EventLogo no CSS vars type " + JSON.stringify(props));
    }

    if (props.type === "DEMO" && props.eventLogoComponent === "BorderUpAndDown") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogoComponent + "demo"}>
                <BorderUpAndDown cssVarsOnly={cssVars} type={props.type} />
            </EventLogoAutoShrink>
        );
    }
    if (props.type !== "DEMO" && props.eventLogo?.name === "BorderUpAndDown") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogo.name}>
                <BorderUpAndDown cssVarsOnly={cssVars} type={props.type} eventLogo={props.eventLogo} />
            </EventLogoAutoShrink>
        );
    }

    if (props.type === "DEMO" && props.eventLogoComponent === "ModernMonogramBadge") {
        // SVG, no need for EventLogoAutoShrink
        return <ModernMonogramBadge cssVarsOnly={cssVars} type={props.type} />;
    }
    if (props.type !== "DEMO" && props.eventLogo?.name === "ModernMonogramBadge") {
        return (
            <ModernMonogramBadge cssVarsOnly={cssVars} type={props.type} eventLogo={props.eventLogo} />
        );
    }

    if (props.type === "DEMO" && props.eventLogoComponent === "HandDrawnHeart") {
        // SVG, no need for EventLogoAutoShrink
        return <HandDrawnHeart  cssVarsOnly={cssVars} type={props.type} />;
    }
    if (props.type !== "DEMO" && props.eventLogo?.name === "HandDrawnHeart") {
        return (
            <HandDrawnHeart cssVarsOnly={cssVars} type={props.type} eventLogo={props.eventLogo} />
        );
    }

    if (props.type === "DEMO" && props.eventLogoComponent === "ModernMonogramStrikethrough") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogoComponent + "demo"}>
                <ModernMonogramStrikethrough cssVarsOnly={cssVars} type={props.type} />
            </EventLogoAutoShrink>
        );
    }
    if (props.type !== "DEMO" && props.eventLogo?.name === "ModernMonogramStrikethrough") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogo.name}>
                <ModernMonogramStrikethrough
                    cssVarsOnly={cssVars}
                    type={props.type}
                    eventLogo={props.eventLogo}
                />
            </EventLogoAutoShrink>
        );
    }

    if (props.type === "DEMO" && props.eventLogoComponent === "ModernMonogramBorderBetween") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogoComponent + "demo"}>
                <ModernMonogramBorderBetween cssVarsOnly={cssVars} type={props.type} />
            </EventLogoAutoShrink>
        );
    }
    if (props.type !== "DEMO" && props.eventLogo?.name === "ModernMonogramBorderBetween") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogo.name}>
                <ModernMonogramBorderBetween
                    cssVarsOnly={cssVars}
                    type={props.type}
                    eventLogo={props.eventLogo}
                />
            </EventLogoAutoShrink>
        );
    }

    if (props.type === "DEMO" && props.eventLogoComponent === "RelaxedByHand") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogoComponent + "demo"}>
                <RelaxedByHand cssVarsOnly={cssVars} type={props.type} />
            </EventLogoAutoShrink>
        );
    }
    if (props.type !== "DEMO" && props.eventLogo?.name === "RelaxedByHand") {
        return (
            <EventLogoAutoShrink type={props.type} key={props.eventLogo.name}>
                <RelaxedByHand cssVarsOnly={cssVars} type={props.type} eventLogo={props.eventLogo} />
            </EventLogoAutoShrink>
        );
    }
    throw new Error("EventLogo: No event logo component found" + JSON.stringify(props));
}